import Header from "@/components/landing/Header";
import HeroSection from "@/components/landing/HeroSection";
import MarqueeRibbon from "@/components/landing/MarqueeRibbon";
import BenefitsSection from "@/components/landing/BenefitsSection";
import PeptidesSection from "@/components/landing/PeptidesSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import ArticlesSection from "@/components/landing/ArticlesSection";
import QuizSection from "@/components/landing/QuizSection";
import FAQSection from "@/components/landing/FAQSection";
import ContactSection from "@/components/landing/ContactSection";
import FooterSection from "@/components/landing/FooterSection";
import { Reveal } from "@/lib/useReveal";

import TransformationsSection from "@/components/landing/TransformationsSection";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F7F5F0] page-fade-in">
      <Header />
      <HeroSection />
      <MarqueeRibbon />
      <QuizSection />
      <Reveal><BenefitsSection /></Reveal>
      <Reveal delay={60}><TransformationsSection /></Reveal>
      <Reveal><PeptidesSection /></Reveal>
      <Reveal delay={60}><ArticlesSection /></Reveal>
      <Reveal><TestimonialsSection /></Reveal>
      <Reveal><FAQSection /></Reveal>
      <Reveal><ContactSection /></Reveal>
      <FooterSection />
    </div>
  );
}
